module.exports = __webpack_public_path__ + "static/media/twitter-512x512.9b63a877.png";